module.exports = __webpack_public_path__ + "static/impact_2-7cb7553bb1f106404ebaef737a323cb3.png";